import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, Stack, useTheme } from "native-base";
import Icon from "../icons/Icon";
import StatusIndicator from "../atoms/StatusIndicator";
import PressableLink from "../atoms/PressableLink";
const BottomNavigation = ({ variant = "primary", navigation }) => {
    const { colors } = useTheme();
    const variants = useMemo(() => ({
        primary: {
            bg: colors.primary[500],
            iconColor: colors.primary[200],
        },
        dark: {
            bg: colors.navBgDark,
            iconColor: colors.gray[500],
        },
    }), [colors]);
    return (_jsx(Stack, Object.assign({ rounded: "full", space: 1.5, direction: "row", justifyContent: "center", alignItems: "baseline", overflow: "hidden", minHeight: 15, bgColor: variants[variant].bg, px: 6, py: 3 }, { children: navigation.map(({ iconName, hasNotification, route, params }, index) => iconName && (_jsx(PressableLink, Object.assign({ p: 1.5, route: route, params: params }, { children: ({ isActive }) => (_jsxs(Box, Object.assign({ position: "relative" }, { children: [hasNotification && (_jsx(StatusIndicator, { hasBorder: false, status: "inactive" })), _jsx(Icon, { size: 24, name: iconName, fill: isActive
                            ? colors.white
                            : variants[variant].iconColor })] }))) }), `bottom-navigation-button-key-${index}`))) })));
};
export default BottomNavigation;
